import { useState, useEffect } from "react";
import { Container, Row, Col, Carousel } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { getFirestore } from "../../config/firebase";
import Loading from "../Loading/Loading";
import ModalContacto from "../ModalContacto/ModalContacto";

const Slider = ({ tipo }) => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const [modelo, setModelo] = useState("");
  const [tipoVehicle, setTipoVehicle] = useState(tipo);

  let location = useLocation();

  // console.log(location.pathname.split("/").pop(), "el tipo");

  useEffect(() => {
    const obtenerDatos = async () => {
      // Verificar si los datos ya están en localStorage
      const datosLocales = sessionStorage.getItem("sliders-ford");
      if (datosLocales) {
        // Parsear los datos de localStorage y establecerlos en el estado
        setBanners(JSON.parse(datosLocales));
        setLoading(false);
      } else {
        const db = getFirestore();
        try {
          const data = await db.collection("sliders-ford").get();
          const arrayData = data.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
          // Guardar los datos obtenidos en localStorage
          sessionStorage.setItem("sliders-ford", JSON.stringify(arrayData));
          // Actualizar el estado con los nuevos datos
          setBanners(arrayData);
        } catch (error) {
          console.error("Error al obtener datos de Firestore: ", error);
        } finally {
          // Asegurar que setLoading se establezca en false independientemente del resultado
          setLoading(false);
        }
      }
    };

    obtenerDatos();
    // La dependencia [] significa que este efecto solo se ejecutará una vez, cuando el componente se monte.
  }, []);

  //console.log(banners[0]);

  const handleModal = (item, index) => {
    // Verificar si es el primer slider y si la fecha no ha vencido
    //const currentDate = new Date();
    //const endDate = new Date("2025-09-09"); // Martes 9 de septiembre de 2025

    // if (index === 0 && currentDate <= endDate) {
    // Si es el primer slider y no ha vencido, abrir el link del Pick Up Experience
    // window.open(
    // "https://oficial.montironi.com/pickupexperience/?utm_source=slider-landing&utm_medium=ford-experience",
    // "_blank"
    // );
    // return;
    // }

    // Comportamiento normal para otros sliders
    setTipoVehicle(item.grandesclientes ? "grandesclientes" : item.plan ? "plan" : "convencional");
    setModelo(item.modelo);
    setModalShow(true);
  };

  return loading ? (
    <Loading styles="mt-5 pt-5 pb-5" />
  ) : (
    <>
      {location.pathname.split("/").pop() === "todos" && (
        <>
          <div className="d-md-block d-none">
            <Carousel>
              {banners[0] &&
                banners[0].desktop.map((item, index) => (
                  <Carousel.Item key={index}>
                    <img
                      className="d-block w-100 img-fluid cursor-pointer"
                      src={item.slider}
                      alt="Montironi Peugeot"
                      onClick={() => handleModal(item, index)}
                    />
                  </Carousel.Item>
                ))}
            </Carousel>
          </div>
          <div className="d-md-none d-block">
            <Carousel>
              {banners[0] &&
                banners[0].mobile.map((item, index) => (
                  <Carousel.Item key={index}>
                    <img
                      className="d-block w-100 img-fluid cursor-pointer"
                      src={item.slider}
                      alt="Montironi Peugeot"
                      onClick={() => handleModal(item, index)}
                    />
                  </Carousel.Item>
                ))}
            </Carousel>
          </div>
        </>
      )}
      {location.pathname.split("/").pop() === "plan" && (
        <>
          <div className="d-md-block d-none">
            <Carousel>
              {banners[0] && banners[0].desktop.filter((b) => b.plan === true).length > 0
                ? banners[0] &&
                  banners[0].desktop
                    .filter((b) => b.plan === true)
                    .map((item, index) => (
                      <Carousel.Item key={index}>
                        <img
                          className="d-block w-100 img-fluid cursor-pointer"
                          src={item.slider}
                          alt="Montironi Peugeot"
                          onClick={() => handleModal(item, index)}
                        />
                      </Carousel.Item>
                    ))
                : banners[0] &&
                  banners[0].desktop.map((item, index) => (
                    <Carousel.Item key={index}>
                      <img
                        className="d-block w-100 img-fluid cursor-pointer"
                        src={item.slider}
                        alt="Montironi Peugeot"
                        onClick={() => handleModal(item, index)}
                      />
                    </Carousel.Item>
                  ))}
            </Carousel>
          </div>
          <div className="d-md-none d-block">
            <Carousel>
              {banners[0] && banners[0].mobile.filter((b) => b.plan === true).length > 0
                ? banners[0] &&
                  banners[0].mobile
                    .filter((b) => b.plan === true)
                    .map((item, index) => (
                      <Carousel.Item key={index}>
                        <img
                          className="d-block w-100 img-fluid cursor-pointer"
                          src={item.slider}
                          alt="Montironi Peugeot"
                          onClick={() => handleModal(item, index)}
                        />
                      </Carousel.Item>
                    ))
                : banners[0] &&
                  banners[0].mobile.map((item, index) => (
                    <Carousel.Item key={index}>
                      <img
                        className="d-block w-100 img-fluid cursor-pointer"
                        src={item.slider}
                        alt="Montironi Peugeot"
                        onClick={() => handleModal(item, index)}
                      />
                    </Carousel.Item>
                  ))}
            </Carousel>
          </div>
        </>
      )}
      {location.pathname.split("/").pop() === "grandesclientes" && (
        <>
          <div className="d-md-block d-none">
            <Carousel>
              {banners[0] && banners[0].desktop.filter((b) => b.grandesclientes === true).length > 0
                ? banners[0] &&
                  banners[0].desktop
                    .filter((b) => b.grandesclientes === true)
                    .map((item, index) => (
                      <Carousel.Item key={index}>
                        <img
                          className="d-block w-100 img-fluid cursor-pointer"
                          src={item.slider}
                          alt="Montironi Peugeot"
                          onClick={() => handleModal(item, index)}
                        />
                      </Carousel.Item>
                    ))
                : banners[0] &&
                  banners[0].desktop.map((item, index) => (
                    <Carousel.Item key={index}>
                      <img
                        className="d-block w-100 img-fluid cursor-pointer"
                        src={item.slider}
                        alt="Montironi Peugeot"
                        onClick={() => handleModal(item, index)}
                      />
                    </Carousel.Item>
                  ))}
            </Carousel>
          </div>
          <div className="d-md-none d-block">
            <Carousel>
              {banners[0] && banners[0].mobile.filter((b) => b.grandesclientes === true).length > 0
                ? banners[0] &&
                  banners[0].mobile
                    .filter((b) => b.grandesclientes === true)
                    .map((item, index) => (
                      <Carousel.Item key={index}>
                        <img
                          className="d-block w-100 img-fluid cursor-pointer"
                          src={item.slider}
                          alt="Montironi Peugeot"
                          onClick={() => handleModal(item, index)}
                        />
                      </Carousel.Item>
                    ))
                : banners[0] &&
                  banners[0].mobile.map((item, index) => (
                    <Carousel.Item key={index}>
                      <img
                        className="d-block w-100 img-fluid cursor-pointer"
                        src={item.slider}
                        alt="Montironi Peugeot"
                        onClick={() => handleModal(item, index)}
                      />
                    </Carousel.Item>
                  ))}
            </Carousel>
          </div>
        </>
      )}
      {location.pathname.split("/").pop() === "convencional" && (
        <>
          <div className="d-md-block d-none">
            <Carousel>
              {banners[0] && banners[0].desktop.filter((b) => b.convencional === true).length > 0
                ? banners[0] &&
                  banners[0].desktop
                    .filter((b) => b.convencional === true)
                    .map((item, index) => (
                      <Carousel.Item key={index}>
                        <img
                          className="d-block w-100 img-fluid cursor-pointer"
                          src={item.slider}
                          alt="Montironi Peugeot"
                          onClick={() => handleModal(item, index)}
                        />
                      </Carousel.Item>
                    ))
                : banners[0] &&
                  banners[0].desktop.map((item, index) => (
                    <Carousel.Item key={index}>
                      <img
                        className="d-block w-100 img-fluid cursor-pointer"
                        src={item.slider}
                        alt="Montironi Peugeot"
                        onClick={() => handleModal(item, index)}
                      />
                    </Carousel.Item>
                  ))}
            </Carousel>
          </div>
          <div className="d-md-none d-block">
            <Carousel>
              {banners[0] && banners[0].mobile.filter((b) => b.convencional === true).length > 0
                ? banners[0] &&
                  banners[0].mobile
                    .filter((b) => b.convencional === true)
                    .map((item, index) => (
                      <Carousel.Item key={index}>
                        <img
                          className="d-block w-100 img-fluid cursor-pointer"
                          src={item.slider}
                          alt="Montironi Peugeot"
                          onClick={() => handleModal(item, index)}
                        />
                      </Carousel.Item>
                    ))
                : banners[0] &&
                  banners[0].mobile.map((item, index) => (
                    <Carousel.Item key={index}>
                      <img
                        className="d-block w-100 img-fluid cursor-pointer"
                        src={item.slider}
                        alt="Montironi Peugeot"
                        onClick={() => handleModal(item, index)}
                      />
                    </Carousel.Item>
                  ))}
            </Carousel>
          </div>
        </>
      )}

      <ModalContacto
        filtrados={""}
        autoSeleccionado={modelo}
        tipoPlan={tipoVehicle}
        vMarca={"ford"}
        vModelo={modelo}
        vVersion={""}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default Slider;

